export const CREDIT_POINTS = {
  airi: 100,
  login: 10,
  subcribe: 300,
  reference: 30,
};
